import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const FormActionContext = createContext();

export const FormActionProvider = ({ children }) => {
  const saveHandlerRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  // Register a function to occur when "Save" is clicked in header
  const registerSaveHandler = useCallback((handler) => {
    console.log("FormActionContext: Registering save handler");
    saveHandlerRef.current = handler;
    return () => {
      console.log("FormActionContext: Unregistering save handler");
      saveHandlerRef.current = null;
    };
  }, []);

  // Trigger the registered handler
  const triggerSave = useCallback(async () => {
    console.log("FormActionContext: triggerSave called. Has handler?", !!saveHandlerRef.current);
    if (saveHandlerRef.current) {
      setIsSaving(true);
      try {
        await saveHandlerRef.current();
      } finally {
        setIsSaving(false);
      }
    } else {
      console.warn("No save handler registered");
    }
  }, []);

  return (
    <FormActionContext.Provider value={{ registerSaveHandler, triggerSave, isSaving }}>
      {children}
    </FormActionContext.Provider>
  );
};

export const useFormAction = () => useContext(FormActionContext);
